const CAPTCHA_RESPONSE_ID = 'g-recaptcha-response';

export function isCaptchaRequired(data : { id : string; messages : string }[]) : boolean {
	return Array.isArray(data) && data.some((element : any) => element.id === CAPTCHA_RESPONSE_ID);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/captcha.ts